import * as PIXI from 'pixi.js';

import { Spine } from 'pixi-spine';
import {
  Text,
  Point,
  Assets,
  Sprite,
  Texture,
  Graphics,
  Container,
  BlurFilter,
  Application,
} from 'pixi.js';
import { gsap } from 'gsap';
import { PixiPlugin } from 'gsap/PixiPlugin';

import { gameLayers } from '../../constants';
import { isMobile } from '../../helpers/isMobile';
import { PixiBase } from '../../core/pixi/PixiBase';
import { PixiGameDrawer } from '../../core/pixi/pixiGameDrawer';
import { pixiResourceHelper } from '../../helpers/pixiResourceHelper';
import { mobileGameConfigs, webGameConfigs } from '../../core/pixi/config';
import {
  gameResources,
  webGameImageSprites,
  mobileGameImageSprites,
} from '../../core/pixi/resources';

import { BetBarDrawer } from './betBarDrawer';
import { MenuBarDrawer } from './menuBarDrawer';
import { SlotBarDrawer } from './slotBarDrawer';
import { SpinBarDrawer } from './spinBarDrawer';
import { IntroBarDrawer } from './introBarDrawer';
import { WinPopupDrawer } from './winPopupDrawer';
import { SlotBoardDrawer } from './slotBoardDrawer';
import { BackgroundDrawer } from './backgroundDrawer';
import { ExpandWeedDrawer } from './expandWeedDrawer';
import { LineWinDrawer } from './lineWinDrawer';
import { FreeBetDrawer } from './freeBetDrawer';
import { PopupDrawer } from './popupDrawer';
import { NotificationDrawer } from './notificationDrawer';
import { JackpotDrawer } from './jackpotDrawer';
import { GambleDrawer } from './gambleDrawer';
import { GameJackpotDrawer } from './gameJackpotDrawer';
import {BoostedJackpotDrawer} from "./boostedJackpotDrawer";
import {BoostedWheelDrawer} from "./boostedWheelDrawer";
import {BoostedInfoDrawer} from "./boostedInfoDrawer";

export class GameMainDrawer extends PixiGameDrawer {
  constructor(props) {
    super(props);
    this.layers = {
      [gameLayers.background]: new BackgroundDrawer(),
      [gameLayers.slotBoard]: new SlotBoardDrawer(),
      [gameLayers.betBar]: new BetBarDrawer(),
      [gameLayers.spinBar]: new SpinBarDrawer(),
      [gameLayers.slotBar]: new SlotBarDrawer(),
      [gameLayers.expandWildBar]: new ExpandWeedDrawer(),
      [gameLayers.lineWinBar]: new LineWinDrawer(),
      [gameLayers.freeBetBar]: new FreeBetDrawer(),
      [gameLayers.jackPotBar]: new JackpotDrawer(),
      [gameLayers.boostedJackpot]: new BoostedJackpotDrawer(),
      [gameLayers.boostedWheel]: new BoostedWheelDrawer(),
      [gameLayers.boostedInfo]: new BoostedInfoDrawer(),
      [gameLayers.introBar]: new IntroBarDrawer(),
      [gameLayers.menuBar]: new MenuBarDrawer(),
      [gameLayers.gameJackpot]: new GameJackpotDrawer(),
      [gameLayers.winPopupBar]: new WinPopupDrawer(),
      [gameLayers.gambleBar]: new GambleDrawer(),
      [gameLayers.popup]: new PopupDrawer(),
      [gameLayers.notification]: new NotificationDrawer(),
      *[Symbol.iterator]() {
        yield this[gameLayers.background];
        yield this[gameLayers.slotBoard];
        yield this[gameLayers.slotBar];
        yield this[gameLayers.expandWildBar];
        yield this[gameLayers.lineWinBar];
        yield this[gameLayers.freeBetBar];
        yield this[gameLayers.betBar];
        yield this[gameLayers.spinBar];
        yield this[gameLayers.gameJackpot];
        yield this[gameLayers.introBar];
        yield this[gameLayers.menuBar];
        yield this[gameLayers.winPopupBar];
        yield this[gameLayers.gambleBar];
        yield this[gameLayers.popup];
        yield this[gameLayers.notification];
        yield this[gameLayers.jackPotBar];
        yield this[gameLayers.boostedJackpot];
        yield this[gameLayers.boostedWheel];
        yield this[gameLayers.boostedInfo];
      },
    };
  }

  get betBar() {
    return this.layers[gameLayers.betBar];
  }

  get jackpotBar() {
    return this.layers[gameLayers.jackPotBar];
  }

  get boostedJackpot() {
    return this.layers[gameLayers.boostedJackpot];
  }

  get boostedInfo() {
    return this.layers[gameLayers.boostedInfo];
  }

  get boostedWheel() {
    return this.layers[gameLayers.boostedWheel];
  }


  get slotBar() {
    return this.layers[gameLayers.slotBar];
  }

  get spinBar() {
    return this.layers[gameLayers.spinBar];
  }

  get gameJackpot() {
    return this.layers[gameLayers.gameJackpot];
  }

  get expandWildBar() {
    return this.layers[gameLayers.expandWildBar];
  }

  get lineWinBar() {
    return this.layers[gameLayers.lineWinBar];
  }

  get freeBetBar() {
    return this.layers[gameLayers.freeBetBar];
  }

  get notificationBar() {
    return this.layers[gameLayers.notification];
  }

  get slotBoard() {
    return this.layers[gameLayers.slotBoard];
  }

  get introBar() {
    return this.layers[gameLayers.introBar];
  }

  get menuBar() {
    return this.layers[gameLayers.menuBar];
  }

  get background() {
    return this.layers[gameLayers.background];
  }

  get winPopupBar() {
    return this.layers[gameLayers.winPopupBar];
  }

  get gambleBar() {
    return this.layers[gameLayers.gambleBar];
  }

  get popupBar() {
    return this.layers[gameLayers.popup];
  }

  setupPixiPlugins() {
    gsap.registerPlugin(PixiPlugin);
    PixiPlugin.registerPIXI(PIXI);
  }

  handleWebOrMobileGameSprites() {
    if (isMobile()) {
      return [
        {
          ...pixiResourceHelper.get(Object.keys(mobileGameImageSprites)[0]).textures,
          ...pixiResourceHelper.get(Object.keys(mobileGameImageSprites)[1]).textures,
          ...pixiResourceHelper.get(Object.keys(mobileGameImageSprites)[2]).textures,
          ...pixiResourceHelper.get(Object.keys(mobileGameImageSprites)[3]).textures,
          ...pixiResourceHelper.get(Object.keys(mobileGameImageSprites)[4]).textures,
          ...pixiResourceHelper.get(Object.keys(mobileGameImageSprites)[5]).textures,
          ...pixiResourceHelper.get(Object.keys(mobileGameImageSprites)[6]).textures,
        },
      ];
    }
    return [
      {
        ...pixiResourceHelper.get(Object.keys(webGameImageSprites)[0]).textures,
        ...pixiResourceHelper.get(Object.keys(webGameImageSprites)[1]).textures,
        ...pixiResourceHelper.get(Object.keys(webGameImageSprites)[2]).textures,
        ...pixiResourceHelper.get(Object.keys(webGameImageSprites)[3]).textures,
        ...pixiResourceHelper.get(Object.keys(webGameImageSprites)[4]).textures,
        ...pixiResourceHelper.get(Object.keys(webGameImageSprites)[5]).textures,
        ...pixiResourceHelper.get(Object.keys(webGameImageSprites)[6]).textures,
        ...pixiResourceHelper.get(Object.keys(webGameImageSprites)[7]).textures,
      },
    ];
  }

  execute(root) {
    return new Promise((resolve) => {
      super
        .loadResource({
          resource: gameResources,
          loader: PixiBase.createLoader(),
        })
        .then(() => {
          root.appendChild(this.pixiApplication.view);
          this.setupPixiPlugins();
          super.setupContainers([
            this.background.BackgroundContainer,
            this.slotBoard.SlotBoardContainer,
            this.slotBar.SlotBarContainer,
            this.expandWildBar.ExpandWildBarContainer,
            this.gameJackpot.GameJackpotContainer,
            this.notificationBar.NotificationContainer,
            this.introBar.IntroBarContainer,
            this.menuBar.MenuBarContainer,
            this.betBar.BetBarContainer,
            this.lineWinBar.LineWinBarContainer,
            this.winPopupBar.WinPopupContainer,
            this.spinBar.SpinBarContainer,
            this.gambleBar.GambleContainer,
            this.freeBetBar.FreeBetContainer,
            this.jackpotBar.JackpotContainer,
            this.boostedJackpot.BoostedJackpotContainer,
            this.boostedWheel.BoostedWheelContainer,
            this.boostedInfo.BoostedInfoContainer,
            this.popupBar.PopupContainer,
          ]);
          const gameAllSprites = this.handleWebOrMobileGameSprites();
          this.gameAllSprites = { ...gameAllSprites[0] };
          [...this.layers].forEach((layer) => {
            layer.execute(isMobile() ? mobileGameConfigs : webGameConfigs, gameAllSprites);
          });
          resolve(true);
        });
    });
  }
}

export const gameMainDrawer = new GameMainDrawer({
  Spine,
  PIXI: { Application, Container, Sprite, Text, Texture, BlurFilter, Assets, Graphics, Point },
  config: isMobile() ? mobileGameConfigs.applicationConfigs : webGameConfigs.applicationConfigs,
});
